import React from 'react';
import Chip from '@material-ui/core/Chip';
import AzureAuthenticationButton from 'lib/azure/AzureAuthenticationButton';
import * as Icon from '@material-ui/icons';
import PropTypes from 'prop-types';
import api from 'api';
import { ToastsStore } from 'react-toasts';

const CLIENT_ID = process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID;

const AzureLink = ({ profile }) => {
    const registerAzureAccount = ({ idToken }) => {
        api.auth.azure
            .register({ idToken })
            .then((result) => {
                //TODO update user in front end
                ToastsStore.success(
                    'Account successfully linked to your azure account'
                );
            })
            .catch((err) => {
                console.error(err);
                ToastsStore.error('Failed to link your azure account');
            });
    };

    return profile.azureOid ? (
        <Chip
            label="Azure account linked"
            onDelete={() => {}}
            deleteIcon={<Icon.Done color={'primary'} size={8} />}
            variant="outlined"
        />
    ) : (
        <>
            <p className={'u-mb-medium'}>
                If you want to link your azure account with your coeus account,
                click the button below.
            </p>
            <AzureAuthenticationButton
                onAuthenticate={registerAzureAccount}
                azureClientId={CLIENT_ID}
            />
        </>
    );
};

AzureLink.propTyes = {
    profile: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AzureLink;
